/**
 * Types of organization configuration documents.
 */
export enum OrgConfigName {
  operator = 'operator',
}

export type OrgConfigNameType = keyof typeof OrgConfigName;
